import Routes from 'routes/index'
import React, { Suspense, useEffect } from 'react'
import Loader from 'components/ui-kit/Loader/index'
import { removeAuthTokenFromCookie } from 'helpers/cookie.helpers'

function App () {
  useEffect(() => {
    removeAuthTokenFromCookie()
  }, [])

  return (
    <Suspense fallback={<Loader />}>
      <Routes />
    </Suspense>
  )
}

export default App
